/**
 * 
 * @param {图片对象} img 
 * @returns 图片原始宽高
 */
const getImgWH = function (img) {
    let size = {}
    if (typeof img.naturalWidth == "undefined") {
        // IE 6/7/8
        size.w = img.width;
        size.h = img.height;
    }
    else {
        // HTML5 browsers
        size.w = img.naturalWidth;
        size.h = img.naturalHeight;
    }
    return size
}
/**
 * 
 * @param {图片地址} src 
 * @returns 图片对象
 */
const imgLoad=function(src){
    return new Promise(function(resolve) {
        let imgObj = new Image();
        imgObj.crossOrigin = 'Anonymous'; //解决跨域
        imgObj.src = src;
        imgObj.onload = function () {
            resolve(imgObj)
        }
    })
  
}
/**
 * 
 * @param {底图地址或者base64} s_img 
 * @param {水印地址或者base64,水印必须为正方形不然会变形} tag_img 
 * @param {生成图大小} c_WH 
 * @param {水印与生成图的比值} tag_scale 
 * @returns 合成图base64
 */
export default function syntheticImg (s_img, tag_img,tag_scale=2/3, c_WH = 200) {
    return new Promise(function(resolve){
            const c = document.createElement("canvas");
            c.width = c_WH;
            c.height = c_WH;
            let ctx = c.getContext('2d');
            ctx.rect(0, 0, c.width, c.height);
            ctx.fillStyle = '#FFFFFF'; //画布填充颜色
            ctx.fill();

            imgLoad(s_img).then(imgObj=>{
                let imgWH=getImgWH(imgObj)
                let isWidthLong=imgWH.w>imgWH.h;
                let scale =isWidthLong?c.width/imgWH.w:c.height/imgWH.h;
                let vWH={
                    w:scale*imgWH.w,
                    h:scale*imgWH.h
                }
                ctx.drawImage(imgObj, (isWidthLong?0:(c.width-vWH.w)/2), (isWidthLong?(c.height-vWH.h)/2:0), vWH.w, vWH.h);
                imgLoad(tag_img).then(imgObj2=>{
                    ctx.drawImage(imgObj2, 0, 0, c.width*tag_scale, c.height*tag_scale);
                    let img = c.toDataURL('image/png');
                    resolve(img)
                })
            });
    })
      
}